//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "@/components/common/header";
import Footer from "@/components/common/footer";
import Right from "@/components/common/Right";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name:'index',
 data () {
 return {
   catelist:[],
   timelive:[],//限时免费
   limit_course_list:[],
   mashangId:'',
    banners:[],
    swiperOption1: {
      notNextTick: true,
      autoplay: true,
      delay: 1500,
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      paginationClickable: true,
      // spaceBetween: 30,
      onSlideChangeEnd: swiper => {
      //这个位置放swiper的回调方法
      this.page = swiper.realIndex + 1;
      this.index = swiper.realIndex;
      },
      pagination: {
      el: ".swiper-pagination"
      }
    },
    numi:0,
    outline:[],//优质好课
    list:[],
    meng:false,
    tui:[],
    liact:0,
    is_appointment:'',
    courselist:[]
  }

 },
 mounted(){
   this.gettui()
   // 分类课程
    // this.$axios.post('/v8/PC_index/PC_index_course',{page:this.catePage}).then(res=>{
    //   if(res.data.code==200){
    //     this.catelist=res.data.data
    //   }
    // })
    this.$axios.post('v8/index/getIndexNewTypeList').then(res=>{
      if(res.data.code==200){
        this.catelist=res.data.data
      }
    })

   //轮播图
    this.$axios.post(`/v8/PC_index/PC_index_banner`).then(res => {
      this.banners = res.data.data;
    });
  // 优质好课
  this.getoutline()
  //限时免费
  this.getfree()
  this.$axios.post(`v8/index/getPcTypeList`).then(res => {
    if(res.data.code== 200) {
        this.list=res.data.data
    } else {
        this.$tips(res.data.msg);
    }
  })
 },
 methods: {
   changeli(index,i,id){
     this.liact=i
    this.$axios.post('v8/index/getTypeCourseList',{type_id:id}).then(res=>{
      if(res.data.code==200){
        this.catelist[index].child_course.pagedata=res.data.data.pagedata
      }
    })
   },
   getfree(){
     if(localStorage.getItem("member_id")){
          var member_id=localStorage.getItem("member_id")
      }else{
          var member_id=''
      }
     this.$axios.post('v8/index/getPcFreeList',{member_id:member_id}).then(res=>{
      if(res.data.code==200){
          this.timelive=res.data.data
          this.limit_course_list=res.data.data.limit_course_list
          // this.mashangId=this.timelive[0].id

          //   this.$axios.post(`/v9/Index/getFreeClass`,{id:this.timelive[0].id,member_id:member_id}).then(res => {
          //     if(res.data.code==200){
          //         this.freecurse=res.data.data
          //         this.is_appointment=res.data.is_appointment
          //     }
          // });
      }
    })
   },
   mashang(id){
        this.$axios.post(`/v9/Member/appointmentInsert`,{id:id}).then(res => {
          if(res.data.code==200){
              this.$tips(res.data.msg);
              this.getfree()
              this.is_appointment=1
          }else{
              this.$tips(res.data.msg);
          }
      });
    },
   gettui(){
        this.$axios.post(`v4/index/featuredList`,{page:this.pagetotal2}).then(res => {
            if(res.data.code== 200 && res.status==200) {
                this.tui=res.data.data.new_array
            } else {
                this.$tips(res.data.msg);
            }
        });
    },
   // 优质好课
    getoutline(){
      this.$axios.post(`/v8/PC_index/featuredList`,{page:this.pagetotal2}).then(res => {
        if(res.data.code== 200) {
            this.outline=res.data.data.new_array
            this.jppage_num = res.data.data.page_num;
        } else {
            this.$tips(res.data.msg);
        }
      })
    },
    through(id,type){
        if(type==2){
          this.$router.push("goodsDetail?id="+id)
        }else if(type==3){
          this.$router.push("zhuanlan?id="+id)
        }else{
          this.$router.push("videoDetail?id="+id)
        }
    },
    changenum(a){
      this.numi=a
      this.meng=true
    },
    leave(){
      this.meng=false
    },
    leaveli(){
      this.numi=-1
    },
    toPage(a){
      this.$router.push(a)
    }
 },

 created () {
 },
 components: {
    Header,
    Footer,
    Right,
    swiper,
    swiperSlide,
  }
}



// WEBPACK FOOTER //
// ./src/components/index/index.vue